import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Snackbar, Alert } from "@mui/material";
const ModalAgregarDireccion = ({
  open,
  onClose,
  recargarDirecciones,
  IdUsuario
}) => {
  const [nuevaDireccion, setNuevaDireccion] = useState("");
  const [error, setError] = useState(false);
  const [alerta, setAlerta] = useState({
    open: false,
    mensaje: '',
    tipo: 'success',
  });
  const esperar = (ms) => new Promise(resolve => setTimeout(resolve, ms));
  const handleGuardar = async () => {
    if (!nuevaDireccion.trim()) {
      setError(true);
      return;
    }

    const nueva = {
      IdUsuario: IdUsuario,
      Direccion: nuevaDireccion.trim()
    };
    try {
      const response = await fetch('https://bibliotecadlago.com/php/agregar_direccion.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(nueva)
      });

      const data = await response.json();

      if (data.success) {
        setAlerta({
          open: true,
          mensaje: `Direccion agregada ${nuevaDireccion}`,
          tipo: 'success',
        });
      } else {
        throw new Error(data.message || 'Error al agregar la direccion');
      }
    } catch (error) {
      console.error('Error al agregar la direccion:', error);
      setAlerta({
        open: true,
        mensaje: 'Hubo un error al agregar la direccion.',
        tipo: 'error',
      });
    }

    // Limpiar estado
    setNuevaDireccion("");
    setError(false);
    recargarDirecciones();
  };

  const handleClose = () => {
    setNuevaDireccion("");
    setError(false);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        Agregar Nueva Dirección
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" mb={2}>
          Escribe la dirección completa donde se entregará el pedido.
        </Typography>

        <TextField
          label="Dirección completa"
          placeholder="Ej: Av. López Mateos 123, Col. Centro, Guadalajara, Jal."
          multiline
          rows={3}
          fullWidth
          value={nuevaDireccion}
          onChange={(e) => {
            setNuevaDireccion(e.target.value);
            if (error) setError(false);
          }}
          error={error}
          helperText={error ? "La dirección es obligatoria" : ""}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}
          variant="contained"
          sx={{
            backgroundColor: "#cf1316",
            "&:hover": { backgroundColor: "#a80f12" }
          }}>
          Cancelar
        </Button>

        <Button
          variant="contained"
          onClick={handleGuardar}
          disabled={!nuevaDireccion.trim()}
          sx={{
            backgroundColor: "#0b7d0b",
            "&:hover": { backgroundColor: "#0a660a" }
          }}
        >
          Guardar Dirección
        </Button>
      </DialogActions>
      <Snackbar
        open={alerta.open}
        autoHideDuration={1000}
        onClose={() => setAlerta({ ...alerta, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setAlerta({ ...alerta, open: false })}
          severity={alerta.tipo}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {alerta.mensaje}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

export default ModalAgregarDireccion;